import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import AgitatorAnchor from 'features/processFlowDiagrams/svg/agitators/agitator-anchor.svg?react'
import AgitatorCrossBeam from 'features/processFlowDiagrams/svg/agitators/agitator-cross-beam.svg?react'
import AgitatorDisc from 'features/processFlowDiagrams/svg/agitators/agitator-disc.svg?react'
import AgitatorFlateBladePaddle from 'features/processFlowDiagrams/svg/agitators/agitator-flate-blade-paddle.svg?react'
import AgitatorGatPaddle from 'features/processFlowDiagrams/svg/agitators/agitator-gat-paddle.svg?react'
import AgitatorHelical from 'features/processFlowDiagrams/svg/agitators/agitator-helical.svg?react'
import AgitatorImpeller from 'features/processFlowDiagrams/svg/agitators/agitator-impeller.svg?react'
import AgitatorPropeller from 'features/processFlowDiagrams/svg/agitators/agitator-propeller.svg?react'
import AgitatorStirrer from 'features/processFlowDiagrams/svg/agitators/agitator-stirrer.svg?react'
import AgitatorTurbine from 'features/processFlowDiagrams/svg/agitators/agitator-turbine.svg?react'
import React from 'react'

export const PID_AGITATORS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'agitator-stirrer',
    name: 'Agitator, Stirrer',
    category: 'agitators',
    svgContent: <AgitatorStirrer />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'agitator-anchor',
    name: 'Agitator (Anchor)',
    category: 'agitators',
    svgContent: <AgitatorAnchor />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'agitator-cross-beam',
    name: 'Agitator (Cross-Beam)',
    category: 'agitators',
    svgContent: <AgitatorCrossBeam />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'agitator-disc',
    name: 'Agitator (Disc)',
    category: 'agitators',
    svgContent: <AgitatorDisc />,
    viewBox: '0 0 80 135',
  },
  {
    id: 'agitator-flate-blade-paddle',
    name: 'Agitator (Flate-Blade Paddle)',
    category: 'agitators',
    svgContent: <AgitatorFlateBladePaddle />,
    viewBox: '0 0 80 140',
  },
  {
    id: 'agitator-gat-paddle',
    name: 'Agitator (Gat Paddle)',
    category: 'agitators',
    svgContent: <AgitatorGatPaddle />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'agitator-helical',
    name: 'Agitator (Helical)',
    category: 'agitators',
    svgContent: <AgitatorHelical />,
    viewBox: '0 0 80 130',
  },
  {
    id: 'agitator-impeller',
    name: 'Agitator (Impeller)',
    category: 'agitators',
    svgContent: <AgitatorImpeller />,
    viewBox: '0 0 80 130',
  },
  {
    id: 'agitator-propeller',
    name: 'Agitator (Propeller)',
    category: 'agitators',
    svgContent: <AgitatorPropeller />,
    viewBox: '0 0 92 132',
  },
  {
    id: 'agitator-turbine',
    name: 'Agitator (Turbine)',
    category: 'agitators',
    svgContent: <AgitatorTurbine />,
    viewBox: '0 0 80 135',
  },
]
